export const checkAlertCount = (alert)=>{
    const providedTimestamp  = alert.endTime;
    const providedDate = new Date(providedTimestamp * 1000);
    const currentDate = new Date();
    const isFuture = providedDate.getTime() > currentDate.getTime();
    return isFuture;
}

export const makeGroups = (groupIdToHierarchyMap , groups)=>{
   const newGroups = groups?.reduce((acc,curr)=>{
                     const {id} = curr;
                     const value = groupIdToHierarchyMap[id];
                     acc = [...acc , value];
                     return acc;
   },[])
   return newGroups?.join(', ');
}

export const makeTimeStamp = (time):string=>{
   const timeStamp = time * 1000;
   const date = new Date(timeStamp);
   const year = date.getFullYear();
   const month = date.getMonth() + 1; 
   const day = date.getDate();
   const hours = date.getHours();
   const minutes = date.getMinutes();
   const seconds = date.getSeconds();
   const formattedDate :string = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;
   return formattedDate;
}